import { ProductBuilderMachineContext } from '../types';
import { productPropertySummary } from './productPropertySummary';

type RomanLineItems = (
  context: ProductBuilderMachineContext,
) => {
  _ROOM: string;
  _BLINDTYPE: string;
  _CHAINTYPE: string;
  _CONTROLTYPE: string;
  _LINING: string;
  _MOUNTTYPE: string;
  _PGMCODE: string;
  _PULLCORDPOS1: string;
  _PULLCORDLENGTH: string;
  _REMARK: string;
  _SIZETYPE: string;
  _STYLE: string;
  _WALLANCHOR: string;
  _WANDLENGTH: string;
  _WANDQTY: string;
  _MODELTYPE: string;
  _dynamic_product: boolean;
};

export const getRomanLineItems: RomanLineItems = context => {
  const { custom } = context;
  const productSummaryCapture = productPropertySummary(context);
  const currentVariant = context.productWithMeasurements
    ? context.productWithMeasurements.data.find(
        ({ attributes: { freight } }) => freight === context.custom.shipping,
      )
    : null;

  const baseProduct = context.products.filter(product =>
    product.variants.some(
      variant =>
        variant.id ===
        (currentVariant ? currentVariant.attributes.base_variant_id : null),
    ),
  );

  const pgmCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('PGMCODE'))
        ?.replace('PGMCODE:', '')
    : '';

  const colourCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('Colour Code'))
        ?.replace('Colour Code: ', '')
    : '';

  let cordPos, chainType, wallAnchor, driveControl;

  chainType = custom.chainType === 'Stainless Steel' ? 'CT002' : 'CT001';
  cordPos =
    custom.chainPosition === 'Left'
      ? 'L'
      : custom.chainPosition === 'Right'
      ? 'R'
      : '';
  wallAnchor = custom.driveControl === 'Drive Control: Chain' ? 'N' : 'Y';
  driveControl =
    custom.driveControl === 'Drive Control: Chainless'
      ? 'Cordless'
      : 'Cordloop';

  return {
    _ROOM: context.custom.roomName,
    _BLINDTYPE: 'Single',
    _CHAINTYPE: driveControl !== 'Cordless' ? chainType : '', // plastic = CT001, Stainless steel = CT002
    _CONTROLTYPE: driveControl, // Chain = Cordloop, Cordless = Cordless
    _LINING:
      context.custom.lining === 'Light Filter' ? 'Translucent' : 'Blackout',
    _MOUNTTYPE: context.custom.fitting === 'Reveal Fit' ? 'IN' : 'OUT',
    _PGMCODE: pgmCode ? pgmCode : '', // Code for material type
    _PULLCORDPOS1: cordPos, // L or R
    _PULLCORDLENGTH: '', // Veneta only
    _REMARK: '', // Empty
    _SIZETYPE: context.custom.fitting === 'Reveal Fit' ? 'WS' : 'MFF',
    _STYLE: 'RM003',
    _WALLANCHOR: wallAnchor,
    _WANDLENGTH: '',
    _WANDQTY: '',
    _MODELTYPE: '',
    _dynamic_product: true,
    _COLORCODE: colourCode ? colourCode : '',
    ...productSummaryCapture,
  };
};
